import { useState, useEffect } from "react";
import { conteudoPorNicho } from "../data/conteudoPorNicho";

const STORAGE_KEY = "evolzap_nicho";
const NICHO_PADRAO_FUNDO = "profissional_autonomo";

export default function useNichoAtual() {
  const [nicho, setNicho] = useState(null);
  const [modalAberto, setModalAberto] = useState(false);

  useEffect(() => {
    const nichoSalvo = localStorage.getItem(STORAGE_KEY);
    if (nichoSalvo && conteudoPorNicho[nichoSalvo]) {
      setNicho(nichoSalvo);
    }
  }, []);

  const selecionarNicho = (slug) => {
    if (!conteudoPorNicho[slug]) return;
    localStorage.setItem(STORAGE_KEY, slug);
    setNicho(slug);
    setModalAberto(false);
  };

  const trocarNicho = () => {
    localStorage.removeItem(STORAGE_KEY);
    setModalAberto(true);
  };

  const conteudo =
    (nicho && conteudoPorNicho[nicho]) ||
    conteudoPorNicho[NICHO_PADRAO_FUNDO];

  return { nicho, conteudo, modalAberto, selecionarNicho, trocarNicho };
}
